module.exports = __webpack_public_path__ + "img/2.bb1af422.png";